import { useEffect, useState } from "react";
import { useBooking } from "@/context/BookingContext";
import api from "@/lib/api";
import { IMAGES } from "@/lib/images";
import Reveal from "@/components/Reveal";
import { ArrowRight, Clock, Sparkles } from "lucide-react";

export default function Services() {
  const { openBooking } = useBooking();
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setGroups(r.data)).catch(() => {});
  }, []);

  return (
    <section id="services" data-testid="services" className="bg-[#FAF8F5] text-[#1C1917] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10">
        <Reveal className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-16">
          <div>
            <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">Find Your Finish</span>
            <h2 className="font-serif text-6xl sm:text-8xl font-medium leading-[0.9] tracking-tight mt-4">The Lash Menu</h2>
          </div>
          <p className="text-[#1C1917]/55 max-w-xs text-sm leading-relaxed">
            Prices shown are current studio rates. Every look is tailored to you in person.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {groups.map((g, i) => {
            const primary = g.items.find((x) => x.type === "Full Set" || x.type === "Single") || g.items[0];
            const infill = g.items.find((x) => x.type === "Infill");
            const img = IMAGES.serviceByGroup[g.group];
            return (
              <Reveal key={g.group} delay={(i % 3) * 0.08}>
                <div
                  data-testid={`service-card-${primary.id}`}
                  className="group bg-white rounded-[1.5rem] overflow-hidden shadow-card hover:shadow-soft hover:-translate-y-1 transition-all duration-300 h-full flex flex-col"
                >
                  <div className="relative aspect-[16/11] overflow-hidden">
                    {img ? (
                      <img src={img} alt={g.group} className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
                    ) : (
                      <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[#EFE9DF] to-[#E4DAC9] text-[#1C1917]/45">
                        <Sparkles size={22} className="text-[#C5B382]" />
                        <span className="text-[10px] tracking-[0.25em] uppercase">Photo coming soon</span>
                      </div>
                    )}
                    <span className="absolute top-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur text-[#1C1917] text-[10px] font-semibold tracking-[0.1em] uppercase px-3 py-1.5 rounded-full">
                      <Clock size={12} className="text-[#C5B382]" /> {primary.duration} min
                    </span>
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <div className="flex items-baseline justify-between">
                      <h3 className="font-serif text-3xl font-medium">{g.group}</h3>
                      <span className="font-serif text-3xl font-medium text-[#C5B382]">${primary.price.toFixed(0)}</span>
                    </div>
                    <p className="mt-3 text-sm text-[#1C1917]/60 leading-relaxed flex-1">{g.description}</p>
                    <div className="mt-6 flex items-center justify-between">
                      {infill ? (
                        <span className="text-[11px] tracking-[0.12em] uppercase text-[#1C1917]/45 font-medium">Infill ${infill.price.toFixed(0)}</span>
                      ) : <span />}
                      <button
                        data-testid={`service-book-${primary.id}`}
                        onClick={() => openBooking(primary.id)}
                        className="group/btn inline-flex items-center gap-2 bg-[#1C1917] hover:bg-[#C5B382] text-white hover:text-[#1C1917] text-[11px] font-semibold tracking-[0.15em] uppercase px-5 py-2.5 rounded-full transition-colors"
                      >
                        Book <ArrowRight size={14} className="group-hover/btn:translate-x-0.5 transition-transform" />
                      </button>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
